import { useState } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { name: '来店スケジュール', href: '#schedule', icon: 'ri-calendar-line' },
    { name: 'YouTube', href: '#youtube', icon: 'ri-youtube-fill' },
    { name: 'TikTok', href: '#tiktok', icon: 'ri-tiktok-fill' },
    { name: 'X', href: '#twitter', icon: 'ri-twitter-x-fill' }
  ];

  return (
    <header className="bg-black text-white shadow-lg fixed w-full top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* ロゴ */}
          <div className="flex-shrink-0">
            <h1 className="text-3xl font-bold" style={{ fontFamily: 'Pacifico, serif' }}>
              <a href="#" className="text-transparent bg-gradient-to-r from-red-400 via-yellow-400 via-green-400 via-blue-400 via-indigo-400 via-purple-400 to-pink-400 bg-clip-text">
                ナナイロ
              </a>
            </h1>
          </div>

          {/* デスクトップナビゲーション */}
          <nav className="hidden lg:flex space-x-1">
            {navItems.map((item, index) => (
              <a
                key={index}
                href={item.href}
                className="flex flex-col items-center p-3 rounded-lg hover:bg-gray-800 transition-colors duration-200 group"
              >
                <i className={`${item.icon} text-xl mb-1 text-red-400 group-hover:text-red-300`}></i>
                <span className="text-xs font-medium">{item.name}</span>
              </a>
            ))}
          </nav>

          {/* モバイルメニューボタン */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden flex items-center justify-center w-10 h-10 rounded-lg hover:bg-gray-800 transition-colors"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* モバイルメニュー */}
        {isMenuOpen && (
          <div className="lg:hidden bg-gray-900 rounded-lg mt-2 p-4 mb-4">
            <div className="grid grid-cols-2 gap-4">
              {navItems.map((item, index) => (
                <a
                  key={index}
                  href={item.href}
                  onClick={() => setIsMenuOpen(false)}
                  className="flex flex-col items-center p-3 rounded-lg hover:bg-gray-800 transition-colors duration-200"
                >
                  <i className={`${item.icon} text-xl mb-2 text-red-400`}></i>
                  <span className="text-sm font-medium">{item.name}</span>
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
